import React from 'react';

function Numb(props) {
	return (
		<svg width='63' height='63' viewBox='0 0 63 63' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M31.4999 62.9999C48.8969 62.9999 62.9999 48.8969 62.9999 31.4999C62.9999 14.103 48.8969 0 31.4999 0C14.103 0 0 14.103 0 31.4999C0 48.8969 14.103 62.9999 31.4999 62.9999Z'
				fill='#399AF4'
			/>
			<path
				d='M47.004 49C47.7759 49.1346 48.3373 48.0577 47.7759 47.3173C45.4601 44.0865 41.9514 42 37.9514 42C34.0215 42 30.4426 44.0865 28.197 47.3173C27.7057 48.0577 28.197 49.1346 28.9689 49C31.6356 48.4615 34.7233 48.1923 37.9514 48.1923C41.2496 48.125 44.2672 48.4615 47.004 49Z'
				fill='#085EAC'
			/>
			<path
				d='M20.2182 20.0758C19.7496 20.0674 19.3145 20.0069 18.9277 19.8924C18.26 19.6947 17.8789 18.9929 18.0765 18.325C18.2743 17.6572 18.9766 17.276 19.6439 17.4738C20.2616 17.657 21.5375 17.5592 22.9965 16.9286C24.4247 16.312 25.4027 15.4204 25.7384 14.8107C26.0743 14.2004 26.8411 13.978 27.4512 14.314C28.0614 14.65 28.2837 15.417 27.9479 16.0269C27.2646 17.2679 25.7876 18.4705 23.9967 19.244C22.6877 19.8096 21.3549 20.0963 20.2182 20.0758Z'
				fill='#085EAC'
			/>
			<path
				d='M53.7086 20.4925C52.5715 20.472 51.2504 20.1376 49.9622 19.5254C48.2004 18.6881 46.7677 17.4331 46.1297 16.1684C45.8158 15.5468 46.0657 14.7883 46.6876 14.4745C47.3095 14.1603 48.0679 14.4107 48.3815 15.0325C48.6953 15.6538 49.6404 16.5798 51.0451 17.2474C52.4806 17.9299 53.7528 18.0736 54.376 17.9129C55.0513 17.7399 55.7381 18.1453 55.9117 18.8198C56.0853 19.4943 55.6794 20.1819 55.0048 20.3556C54.6142 20.4562 54.1771 20.5009 53.7086 20.4925Z'
				fill='#085EAC'
			/>
			<path
				opacity='0.5'
				d='M38.25 58.3497C20.8531 58.3497 6.75019 44.2467 6.75019 26.8499C6.75019 17.5553 10.7765 9.20234 17.1792 3.43652C6.98139 8.65073 0 19.26 0 31.5C0 48.8969 14.1029 62.9998 31.4998 62.9998C39.6023 62.9998 46.9892 59.9397 52.5706 54.9135C48.2741 57.1102 43.407 58.3497 38.25 58.3497Z'
				fill='#075AA6'
			/>
			<path
				d='M26.0661 40.8771C26.0661 43.1564 24.281 44.9665 22.0331 44.9665C19.7851 44.9665 18 43.1564 18 40.8771C18.0661 39.2011 20.3802 35.1117 21.5041 33.3017C21.7686 32.8994 22.3636 32.8994 22.6281 33.3017C23.7521 35.1117 26.0661 39.2011 26.0661 40.8771Z'
				fill='#085EAC'
			/>
			<path
				d='M26.879 30.8107C29.0359 30.8107 30.7843 29.0622 30.7843 26.9054C30.7843 24.7485 29.0359 23 26.879 23C24.7221 23 22.9736 24.7485 22.9736 26.9054C22.9736 29.0622 24.7221 30.8107 26.879 30.8107Z'
				fill='#085EAC'
			/>
			<path
				d='M48.6895 30.8107C50.8464 30.8107 52.5949 29.0622 52.5949 26.9054C52.5949 24.7485 50.8464 23 48.6895 23C46.5327 23 44.7842 24.7485 44.7842 26.9054C44.7842 29.0622 46.5327 30.8107 48.6895 30.8107Z'
				fill='#085EAC'
			/>
		</svg>
	);
}

export default Numb;
